<template>
  <div class="project-info-page">
    <!-- 外层 card-m：card-title 和 card-box 都在这里面
         ⚠️ cardHeight="100%"（原来 180% 会撑破容器）
         class="project-info-card" 会落到 card-m 的根元素 .card-main 上，
         下面靠它精确指定「外层的 card-box」 -->
    <card-m
      class="project-info-card"
      cardWidth="100%"
      cardHeight="100%"
      maxHeight="unset"
      :show-filter="false"
    >

      <template slot="card-title">
        <AppBreadcrumb
          page-name="项目信息"
          :list="breadcrumbList"
        >
          <template #right-btn>
            <el-button
              type="primary"
              size="mini"
              @click="goToProjectAftersale"
            >
              售后
            </el-button>
          </template>
        </AppBreadcrumb>
      </template>

      <!-- 主内容区域 - 重新设计布局 -->
      <template slot="card-box">
        <!-- 使用Grid容器包裹所有内容 -->
        <div class="project-dashboard">
          <!-- 左侧基本信息区域 -->
          <div class="basic-info-section">
            <card-m
              title="基本信息"
              cardWidth="100%"
              :minHeight="'100%'"
              :cardHeight="'100%'"
              :show-export="true"
              export-file-name="项目基本信息"
              @export="handleExportBasicInfo"
            >
              <template slot="card-box">
                <CardInfoTable
                  ref="basicInfoTable"
                  :data="basicInfoItems"
                  :items-per-row="2"
                  :label-width="isMobile ? '30%' : '20%'"
                  :row-height="isMobile ? '26px' : '28px'"
                  :font-size="isMobile ? '12px' : '14px'"
                  :label-bg-color="'rgba(37, 100, 207, 0.08)'"
                  :border-color="'#dcdfe6'"
                  :empty-text="''"
                  export-file-name="项目基本信息"
                />
              </template>
            </card-m>
          </div>

          <!-- 右侧投标信息区域 -->
          <div class="bid-info-section">
            <card-m
              title="投标信息"
              cardWidth="100%"
              :minHeight="'100%'"
              :cardHeight="'100%'"
            >
              <template slot="card-box">
                <div class="card_content">
                  <div class="card_content_item">
                    <div class="card_content_item_title">预计中标率</div>
                    <el-progress
                      width="80"
                      :stroke-width="8"
                      type="circle"
                      :percentage="
                        (projectInfo.预计中标率 * 100).toFixed(1)
                          ? (projectInfo.预计中标率 * 100).toFixed(1)
                          : 0
                      "
                    ></el-progress>
                  </div>
                  <div class="line"></div>
                  <div class="card_content_item">
                    <div class="card_content_item_title">客户信用评价</div>
                    <div class="img_box" v-if="projectInfo.客户信用评价 == 'A'">
                      <img src="../assets/imgs/A.png" alt="" />
                      <div class="img_info">较好</div>
                    </div>
                    <div class="img_box" v-if="projectInfo.客户信用评价 == 'B'">
                      <img src="../assets/imgs/B.png" alt="" />
                      <div class="img_info">一般</div>
                    </div>
                    <div
                      class="img_box"
                      v-else-if="projectInfo.客户信用评价 == 'C'"
                    >
                      <img src="../assets/imgs/C.png" alt="" />
                      <div class="img_info">较差</div>
                    </div>
                    <div
                      class="img_box"
                      v-else-if="projectInfo.客户信用评价 == '网点'"
                    >
                      <img src="../assets/imgs/wangdian.png" alt="" />
                      <div class="img_info">网点</div>
                    </div>
                    <div
                      class="img_box"
                      v-else-if="projectInfo.客户信用评价 == '中间商'"
                    >
                      <img src="../assets/imgs/zhongjianshang.png" alt="" />
                      <div class="img_info">中间商</div>
                    </div>
                  </div>
                  <div class="line"></div>

              <div class="card_content_item bid-grid-row">
                <div class="bid-grid-col">
                  <div class="card_content_item_title">招标方式</div>
                  <div class="card_content_item_info">{{ projectInfo.招标方式 }}</div>
                </div>

                <div class="bid-grid-col">
                  <div class="card_content_item_title">中标原则</div>
                  <div class="card_content_item_info">{{ projectInfo.中标原则 }}</div>
                </div>
              </div>

              <div class="line"></div>

              <div class="card_content_item bid-grid-row">
                <div class="bid-grid-col">
                  <div class="card_content_item_title">投标日期</div>
                  <div class="card_content_item_info">{{ projectInfo.投标日期 }}</div>
                </div>

                <div class="bid-grid-col">
                  <div class="card_content_item_title">业务部门</div>
                  <div class="card_content_item_info">{{ projectInfo.业务部门 }}</div>
                </div>
              </div>
              </div>
              </template>
            </card-m>
          </div>

          <!-- 底部合同列表区域 -->
          <div class="contract-section">

            <ContractProgress
              :key="currentProjectNo"
              title="合同信息"
              ref="contractProgressRef"
              :contractProgressData="contractProgressData"
              :totalProgressCounts="totalProgressCounts"
              :loading="loading"
              :contractProgressSearchKeyword="contractProgressSearchKeyword"
              :progressPageSize="progressPageSize"
              :currentProgressPage="currentProgressPage"
              :showScheduleCard="false"
              :showFilterTool="true"
              @get-data="handleGetData"
              @aftersale-click="handleAftersaleClick"
              @contractinfo-click="handleContractLinkClick"

            />

          </div>
        </div>
      </template>
    </card-m>


  </div>
</template>

<script>
// 导入Vue、Axios等
import { getContractListFromProject, getProjectHomeList } from '@/api/mainapi.js';
// import { getContractIdList, getContractListFromProject, getProjectHomeList, getDataList, getProjectFollow } from '@/api/mainapi.js';
import { convertDateFormat } from '@/utils/tools.js';
import ContractProgress from '@/home/homeContracts/contractProgress';
import UserInfoUtils from '@/utils/userInfoUtils.js';
import CardM1 from '../components/card/card-M1.vue';

export default {
  components: {
    ContractProgress,
    CardM1
  },
  // name: 'classification',
  data() {
    return {
      projectId: '', //项目ID
      projectNo: '',   // ✅ 新增：项目编号

    currentProjectNo: '',
    // ✅ 新增：存列筛选参数
    columnFilterValues: {},

      // ✅ 新增：ContractProgress 需要的状态
      contractProgressSearchKeyword: '',
      
      currentProgressPage: 1,
      progressPageSize: 50,
      // ✅ 合同信息列表加载态（模板 :loading 绑定的就是这个字段）
      loading: false,
      contractProgressData: [],

      // 原始信息项
      basicInfoItems: [
        { label: '录入时间', value: '' },
        { label: '更新时间', value: '' },
        { label: '状态', value: '' },
        { label: '产品型号', value: '' },
        { label: '预计金额', value: '' },
        { label: '业主单位', value: '' },
        { label: '所属行业', value: '' },
        { label: '业务部门', value: '' },
        { label: '业务员', value: '' }
      ],
      projectInfo: {
        业主单位: '',
        业务员: '',
        业务部门: '',
        中标原则: '',
        产品型号: '',
        客户信用评价: '',
        录入时间: '',
        投标日期: '',
        招标方式: '',
        更新时间: '',
        所属行业: '',
        项目名称: '',
        项目状态: '',
        项目编号: '',
        预计中标率: '',
        预计金额: ''
      },
      currentSelectContractId: '', //当前选中的合同号id
      dialogVisible: false, //合同号选择弹框是否可见
      contractIdList: [], //合同号列表
      // 弹框合同号列表的表头
      contracIdtListColumn: [
        {
          prop: 'finterid',
          label: 'ID'
        },
        {
          prop: 'fbillno',
          label: '合同号'
        }
      ],
    };
  },
  computed: {
    projectName() {
      return this.projectInfo.项目名称 || '';
    },

    /** ✅ 面包屑数据（核心） */
    breadcrumbList() {
      return [
        {
          label: '项目主页',
          to: '/homepage/projects'
        },
        {
          label: this.projectInfo.项目名称 || '项目详情',
          tooltip: this.projectInfo.项目名称 || '',
          disabled: true
        }
      ];
    },

    isMobile() {
      return window.innerWidth <= 768;
    }
  },
  mounted() {
    
    // 从路径参数获取项目名称
    // const projectName = this.$route.params.projectName || this.$route.params.projectId;
    const projectNo = this.$route.params.projectNo;
    // const projectNo = this.$route.query.projectNo;
    
    if (projectNo) {
      // 解码URL参数
      // const decodedName = decodeURIComponent(projectName);
      const decodeNo = decodeURIComponent(projectNo);
      this.currentProjectNo = decodeNo; // ✅ 存储项目编号
      this.getProjectDetailByNo(decodeNo);
      this.getContractProgressList(decodeNo);

    } 
  },
  methods: {
  // ✅ 跳转到【项目维度】售后信息页面
  goToProjectAftersale() {
    const projectName = this.projectName;
    const projectNo = this.$route.params.projectNo || '';

    // ✅ 存入 sessionStorage，防止刷新丢失
    sessionStorage.setItem('currentProjectName', projectName);

    this.$router.push({
      name: '项目售后信息',
      params: {
        projectName,
        projectNo
      }
    });

    this.$EventBus.$emit(
      'currentPath',
      `/homepage/project/${encodeURIComponent(projectName)}/aftersale`
    );
  },

  // ✅ 处理合同号点击跳转
  handleContractLinkClick(data) {
    const contractNo = data.row.合同编号;
    const contractName = data.row.合同名称;

    // 缓存合同名称，供 contractinfo 面包屑显示
    sessionStorage.setItem(`contract_name_${contractNo}`, contractName || contractNo);

    const projectName = this.projectName;

    this.$router.push({
      name: '合同信息1',
      params: {
        projectName,
        contractId: contractNo
      }
    });

    this.$EventBus.$emit(
      'currentPath',
      `/homepage/project/${encodeURIComponent(projectName)}/contract/${contractNo}`
    );
  },

      // 处理链接点击事件
    handleAftersaleClick(data) {
      this.goToAftersaleInfo(data);
    },

    goToAftersaleInfo(data) {
      // ✅ 来自项目维度
      const projectName = this.projectName;
      const contractId = data.合同编号;
      this.$router.push({
        name: '合同售后信息2', // ✅ 项目维度
        params: {
          projectName,
          contractId,
        }
      });
      this.$EventBus.$emit(
        'currentPath',
        `/homepage/project/${encodeURIComponent(projectName)}/contract/${contractId}/aftersale`
      );
      // this.$router.push(`/homepage/contract/aftersale/${data.row.合同名称}`);
      // this.$EventBus.$emit('currentPath', `/homepage/contract/aftersale/${data.row.合同名称}`);
    },

    // 新增方法：获取当前用户工号
    getCurrentUserCode() {
      const userCode = UserInfoUtils.getUserCode();
      if (!userCode) {
        this.$message.warning('未获取到用户信息，请重新登录');
        this.$router.push('/login');
        return null;
      }
      return userCode;
    },

    /** ✅ 获取合同进度列表（适配新接口） */
async getContractProgressList(projectNo = this.currentProjectNo, pageNo = this.currentProgressPage) {
  // 打开页面就转圈，等接口回来再关
  this.loading = true;
  const userCode = this.getCurrentUserCode();
  if (!userCode) {
    this.loading = false;
    return;
  }

  // ✅ 1. 取出列筛选参数
  const filter = this.columnFilterValues || {};

  // ✅ 2. 时间范围：从列筛选取
  const startDate = filter['创建时间'] ? filter['创建时间'][0] : '';
  const endDate = filter['创建时间'] ? filter['创建时间'][1] : '';

  // ✅ 4. 拼接口参数（和合同主页逻辑对齐）
  const params = {
    // 合同名称：列筛选优先，其次顶部搜索
    contractName: filter['合同名称'] || '',
    contractNo: this.contractProgressSearchKeyword || '',
    // 评审进度
    reviewProgress: filter['评审进度'] || '',
    // 合同进度
    contractProgress: filter['合同进度'] || '',
    // 时间范围（已处理优先级）
    startDate: startDate,
    endDate: endDate,
    sortField: "field0211",
    // 客户
    customer: filter['客户'] || '',
    // 销售员
    salesPerson: filter['销售员'] || '',
    // 更新日期
    updateStartDate: filter['更新日期'] ? filter['更新日期'][0] : '',
    updateEndDate: filter['更新日期'] ? filter['更新日期'][1] : '',
    // 审核时间
    reviewStartDate: filter['审核时间'] ? filter['审核时间'][0] : '',
    reviewEndDate: filter['审核时间'] ? filter['审核时间'][1] : '',
    // 签订交货期
    signStartDate: filter['签订交货期'] ? filter['签订交货期'][0] : '',
    signEndDate: filter['签订交货期'] ? filter['签订交货期'][1] : '',
    // 回复交货期
    replyStartDate: filter['回复交货期'] ? filter['回复交货期'][0] : '',
    replyEndDate: filter['回复交货期'] ? filter['回复交货期'][1] : '',
    userCode: userCode,
    // 销售部门
    department: filter['销售部门'] || '',
    // 分页
    Paging_pageNumber: Number(pageNo),
    Paging_pageSize: Number(this.progressPageSize),
    // ✅ 核心：固定当前项目编号，只筛当前项目下的合同
    projectNo: projectNo,
    // 预留字段
    afterSalesNum: filter['售后总数量'] || '',
    branchNumber: filter['网点号'] || '',
    deliveryProgress: filter['交付进度'] || '',
    contractAmount: filter['销售金额'] || '',
    paymentRatio: filter['回款比例'] || '',
    hasException: filter['数据状态码'] || '',  // ✅ 状态列筛选：'true' = 只看有异常的合同，'' = 全部
  };

  try {
    const res = await getContractListFromProject(params);

    if (res.data.code === 200) {
      const totalCount = parseInt(res.data.data.totalCount) || 0;
      if (totalCount === 0) {
        this.contractProgressData = [];
        this.totalProgressCounts = 0;
        this.$message.info('未查询到合同信息');
        return;
      }
      this.contractProgressData = this.processContractData(res.data.data.contractInfo || []);
      this.totalProgressCounts = totalCount;
    } else {
      this.$message.error('获取数据失败');
    }
  } catch (err) {
    this.$message.error('网络错误');
  } finally {
    // 成功/失败都结束加载
    this.loading = false;
  }
},

    /** ✅ 数据处理（适配新接口返回结构） */
    processContractData(data) {
      if (!Array.isArray(data)) return [];

      return data.map(item => {
        // ✅ 状态圆点颜色：hasException 优先（红色），其次按「评审进度」
        let 数据状态码 = '';
        let 状态详情 = item.评审进度 || '';
        if (item.hasException === true || item.hasException === 'true') {
          数据状态码 = 0; // 有异常 → 红色，优先级最高
          状态详情 = item.评审进度 ? `${item.评审进度}（存在异常）` : '存在异常';
        } else if (item.评审进度 === '已提交') 数据状态码 = 2;
        else if (item.评审进度 === '已审核') 数据状态码 = 1;
        else if (item.评审进度 === '暂存无用') 数据状态码 = 0;

        return {
          '创建时间': this.formatDate(item.创建时间),
          '审核时间': this.formatDate(item.审核时间),
          '合同编号': item.合同编号,
          '合同名称': item.合同名称,
          '评审进度': item.评审进度,
          '客户': item.客户,
          '销售员': item.销售员,
          '销售金额': item.合同总额 || item.合同金额_含税, // 优先使用合同总额
          '签订交货期': this.formatDate(item.签订交货期),
          '回复交货期': this.formatDate(item.回复交货期),
          '计划完成时间': this.formatDate(item.planFinishTime && item.planFinishTime.plandate),
          '交付进度': item.交付进度,
          '网点号': item.网点号,
          '总字号': item.总字号,
          '回款': item.回款总额 || item.回款总额_含税, // 优先使用回款总额
          '回款比例': Number(item.回款比例) > 1 ? 1 : Number(item.回款比例),
          '合同状态': item.合同进度, // 新接口使用合同进度作为状态
          '是否推送': '', // 新接口无此字段，暂留空
          'id': item.合同编号, // 使用合同编号作为唯一标识
          '数据状态码': 数据状态码,
          '状态详情': 状态详情, // 悬浮提示显示关联的评审进度文字（有异常时追加「存在异常」）
          // ✅ 后端新增字段：是否有异常（true → 状态圆点强制红色，可点击查看异常详情）
          'hasException': item.hasException === true || item.hasException === 'true',
          // 新增字段
          '销售部门': item.销售部门,
          '项目编号': item.项目编号,
          '工号': item.工号,
          '更新日期': this.formatDate(item.更新日期),
          'RN': item.RN,
          '售后总数量': item.售后总数量,
          // 有无问题：后端 hasIssue = true 表示有问题，统一成布尔值供「有无问题」列渲染（true→有 / false→无）
          'hasIssue': item.hasIssue === true || item.hasIssue === 'true'
        };
      });
    },

    /** ✅ 接收 ContractProgress 的事件 */
    handleGetData(filters) {
  this.contractProgressSearchKeyword = filters.contractNo || '';
  this.currentProgressPage = filters.currentPage || 1;
  this.progressPageSize = filters.pageSize || 50;
  
  // ✅ 新增：存下列筛选值（核心）
  this.columnFilterValues = filters.columnFilterValues || {};

  this.getContractProgressList();
    },

/** ✅ 格式化日期 */
formatDate(dateStr) {
  if (!dateStr) return '';
  return dateStr.length > 10 ? dateStr.slice(0, 10) : dateStr;
},

// =======================================分隔=====================================================================
// ✅ 根据项目编号获取项目详情（使用新接口）
async getProjectDetailByNo(projectNo) {
  if (!projectNo) {
    this.$message.warning('缺少项目编号');
    return;
  }

  // ✅ 新增：切换项目时清空所有筛选条件
  this.columnFilterValues = {};
  this.contractProgressSearchKeyword = '';
  this.currentProgressPage = 1;
  
  

  const params = {
    Paging_pageNumber: 1,
    Paging_pageSize: 1,     // ✅ 只要一条
    status: '',             // 项目状态
    name: '',              // 业务员姓名
    projectName: '',       // 项目名称
    startDate: '',         // 开始日期
    endDate: '',           // 结束日期
    projectNo: projectNo,  // ✅ 关键：项目编号
    sortField: "field0014", // ✅ 排序字段（固定值）
    estimatedAmount: "",    // 预计金额
    contractNum: "",       // 合同数量
    contractAmount: "",    // 合同金额
    contractReviewNum: "", // 审核合同数
    productType: "",       // 产品大类
    updateStartDate: "",   // 更新开始日期
    updateEndDate: "",     // 更新结束日期
    biddingStartDate: "",  // 投标开始日期
    biddingEndDate: "",  // 投标结束时间
    department:""     
  };

  try {
    const res = await getProjectHomeList(params);

    // if (res.data.code !== 200 || !res.data.data?.projectList?.length) {
    //   this.$message.error('未查询到项目信息');
    //   this.resetProjectInfo();
    //   return;
    // }

    const item = res.data.data.projectList[0];

    // ✅ 日期格式化
    const format = (val) => convertDateFormat(val);

  // ✅ 存缓存（项目编号 → 项目名称）
  sessionStorage.setItem(
    `project_name_${projectNo}`,
    item.项目名称 || ''
  );
    // ✅ 统一赋值（没有的就置空）
    this.projectInfo = {
      项目名称: item.项目名称 || '',
      项目编号: item.项目编号 || '',
      项目状态: item.项目阶段 || '',

      业主单位: item.业主单位 || '',
      所属行业: item.所属行业 || '',
      业务部门: item.业务部门 || '',
      业务员: item.业务员 || '',
      业务员工号: item.业务员工号 || '',

      产品型号: item.产品大类 || '',
      招标方式: item.招标方式 || '',
      中标原则: item.中标原则 || '',
      预计中标率: item.预计中标率 || '',

      预计金额: item.预计金额 || '',
      合同数量: item.合同数量 || 0,
      合同总金额: item.合同总金额 || 0,
      已审核合同数量: item.已审核合同数量 || 0,

      录入时间: this.formatDate(item.录入时间) ,
      更新时间: this.formatDate(item.更新时间),
      投标日期: this.formatDate(item.预计投标日期),

      客户信用评价: item.客户信用等级 || '',               // 后端未返回，置空
    };

    this.projectId = item.RN || '';
    // ✅ 同步基本信息表格
    this.updateBasicInfoItems();

    console.log('✅ 项目详情加载成功', this.projectInfo);
  } catch (err) {
    console.error(err);
    this.$message.error('获取项目详情失败');
    this.resetProjectInfo();
  }
},

// ✅ 重置 projectInfo（防止脏数据）
resetProjectInfo() {
  Object.keys(this.projectInfo).forEach(key => {
    this.projectInfo[key] = '';
  });
},








    // // 返回项目主页
    // goToProjects() {
    //   this.$router.push('/homepage/projects');
    //   this.$EventBus.$emit('currentPath', '/homepage/projects');
    // },    

    // // 根据name查询项目详情
    // async getDetilByName(name) {
    //   const params = {
    //     ProjectName: name,
    //     Type: 'Project'
    //   };
    //   const res = await getContractIdList(params);

    //   this.projectInfo = res.data.data[0];
    //   this.projectInfo.录入时间 = convertDateFormat(this.projectInfo.录入时间);
    //   this.projectInfo.投标日期 = convertDateFormat(this.projectInfo.投标日期);
    //   this.projectInfo.更新时间 = convertDateFormat(this.projectInfo.更新时间);
    //   this.projectId = res.data.data[0].id;
      
    //   // 更新原始信息项
    //   this.updateBasicInfoItems();
    //   console.log('获取项目详情', this.projectInfo);
    // },
    
    // 更新原始信息项
    updateBasicInfoItems() {
      this.basicInfoItems = [
        { label: '录入时间', value: this.projectInfo.录入时间 },
        { label: '更新时间', value: this.projectInfo.更新时间 },
        { label: '状态', value: this.projectInfo.项目状态 },
        { label: '产品型号', value: this.projectInfo.产品型号 },
        { label: '预计金额', value: this.projectInfo.预计金额 },
        { label: '业主单位', value: this.projectInfo.业主单位 },
        { label: '所属行业', value: this.projectInfo.所属行业 },
        { label: '业务部门', value: this.projectInfo.业务部门 },
        { label: '业务员', value: this.projectInfo.业务员 }
      ];
    },

    /** 导出基本信息表格 */
    handleExportBasicInfo() {
      if (this.$refs.basicInfoTable && this.$refs.basicInfoTable.handleExport) {
        this.$refs.basicInfoTable.handleExport();
      }
    },
 
  }
};
</script>

<style scoped lang="scss">

/* ============================================================
   电脑端布局（和 homepage.vue 的 .main-view 同一套逻辑）
   ------------------------------------------------------------
   高度链：
     .main-view(homepage，height:100% + min-height:560px)
       → .project-info-page(height:100%)
         → .card-main(外层 card-m，height:100%)
             ├─ .card-top  ← card-title，自动高度
             └─ .card-box  ← ★ 应该 = card-main 高度 − card-title 高度
                  → .project-dashboard
                      ├─ 上排：basic-info + bid-info（固定高度 $top-row-h）
                      └─ 下排：contract-section（吃掉剩余高度）
   ============================================================ */
$top-row-h: 220px;   /* 上排两张卡的固定高度，想调只改这一个值 */
$outer-card-bg: #f5f5f5;  /* 最外层那张 card-m 的底色（黄），想换色只改这一个值 */

/* 页面根：撑满 .main-view */
.project-info-page {
  height: 100%;
  box-sizing: border-box;
}

/* 外层 card-m：撑满页面 */
.project-info-card {
  height: 100% !important;
  width: 100% !important;

  /* ✅ 最外层这张卡片不要外边框
     card-M 现在的默认样式是「四边 1px 描边 + 外阴影」，这里两个都关掉，
     只当一个纯容器（里面的三张卡片边框不受影响，照常有） */
  border: none !important;
  box-shadow: none !important;

  /* ✅ 底色改成黄色 */
  // background: $outer-card-bg !important;
}

/* ⚠️★ 真正修掉「card-box 超出 main-view」的一步
   card-M 里 .card-box 写死的是 height:100%，跟上面的 .card-top(card-title) 一叠加就超出 card-main；
   更关键的是：.card-box 是 .card-main(flex 列) 的 flex 项，默认 min-height:auto
   （自动最小尺寸 = 内容的 min-content 高度），合同表格内容一高它就拒绝收缩，
   直接把 card-main / main-view 顶破 —— 这就是溢出的根因。
   三条一起改：
     flex:1 1 auto → 正好吃掉「card-main 减去 card-title」的剩余高度
     min-height:0  → 解除 flex 项「不能小于内容高度」的限制（★ 关键就是它）
     height:auto   → 别再按 100% 算，高度交给 flex 分配 */
.project-info-card ::v-deep .card-box {
  flex: 1 1 auto !important;
  height: auto !important;
  min-height: 0 !important;
  box-sizing: border-box;

  /* ⚠️★ 必须变成 flex 列容器（card-M 里 .card-box 默认是 block）
     它的 height 是 auto，里面 .project-dashboard 的 height:100% 就解析不出来
     —— 百分比遇到 auto 父级会退化成 auto，Grid 变成「按内容撑高」：
        上排两张卡既不是 210px，内容还会互相盖住。
     改成 flex 后，.project-dashboard 靠 flex:1 拿到确定高度，
        $top-row-h 1fr 才能真正按「上排固定 210 / 下排吃剩余」分配。
     → card-main（project-info-card）才能真正撑满 project-info-page */
  display: flex !important;
  flex-direction: column !important;
}

/* 主布局容器：吃掉 card-box 的全部高度，再切成「固定行 + 剩余行」 */
.project-dashboard {
  /* ⚠️ 不要只写 height:100%
     父级 .card-box 的 height 是 auto，百分比解析不出来会退化成 auto，
     Grid 就变成按内容撑高 —— 上排两张卡既不是 210px，内容还会互相盖住。
     改由 flex 撑满 card-box（card-box 已改成 flex 列容器），高度才是确定的。 */
  flex: 1 1 auto !important;
  min-height: 0 !important;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr;      /* 左右两栏，等宽 */
  grid-template-rows: $top-row-h 1fr;  /* ✅ 上排固定高度，下排占剩余 */
  grid-template-areas:
    "basic-info bid-info"
    "contract contract";
  gap: 10px; /* 区域间距 */
}

/* 上排两张卡：固定高度（$top-row-h） */
.basic-info-section,
.bid-info-section {
  /* ⚠️ 删掉原来的 min-height:250px：它属于「不允许收缩」的一类，会把固定行顶大 */
  min-height: 0;
  /* ⚠️ 这里不要写 overflow:hidden —— 卡片正好填满这一格，
     一裁剪就会把 card-M 的「右 + 下阴影」一起裁掉，只剩个生硬的方块。
     上排是固定高度、内容装得下，本来也不需要裁。 */
  display: flex;
  flex-direction: column;

  /* 内层 card-m 撑满这一格（同样去掉自带的 20px 右边距，否则会溢出网格单元） */
  > .card-main {
    width: 100% !important;
    margin-right: 0 !important;
    height: 100% !important;
  }
}

/* ✅ 让上面两张卡片高度严格相等（都是 210px）：
   投标信息的内容（.card_content height:50% + .card_content_item height:180px + 多行 .bid-grid-row）
   总高超过 card-box（= 210 − 40 ≈ 170px），不加约束的话内容会把 card-main 撑高，
   看上去比「基本信息」高一截。
   给两张卡的 card-box 加 overflow-y:auto —— 内容在卡片内部滚，卡片本体始终是 210px。
   ⚠️ 用 overflow:auto 不是 hidden：card-box 在 card-main 内部，不会裁 card-main 的边框 / 阴影。 */
.basic-info-section ::v-deep .card-box,
.bid-info-section ::v-deep .card-box {
  overflow-y: auto;
}

/* 基本信息区域 - 左上角 */
.basic-info-section {
  grid-area: basic-info;
}

/* 投标信息区域 - 右上角 */
.bid-info-section {
  grid-area: bid-info;
}

/* 合同列表区域 - 底部跨两列，吃掉剩余高度 */
.contract-section {
  grid-area: contract;
  min-height: 0;   /* ⚠️ 允许收缩，里面的表格自己滚动，不把外层顶破 */
  /* ⚠️ 同样不加 overflow:hidden，否则会把卡片的「右 + 下阴影」裁掉；
     里面的表格由 card-table 自己滚动，不会往外溢 */
  display: flex;
  flex-direction: column;

  /* ContractProgress 的根元素：撑满这一格 */
  > * {
    flex: 1;
    min-height: 0;
  }
}

/* 投标信息内容样式 */
.bid-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 14px;
  height: 100%;
  box-sizing: border-box;
}

.bid-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex: 1;
  min-height: 0; /* 允许子元素压缩 */
}

.bid-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 12px;
  background: rgba(37, 100, 207, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(37, 100, 207, 0.1);
  transition: all 0.3s ease;
  min-height: 120px; /* 设置最小高度 */
  box-sizing: border-box;
}

.bid-item:hover {
  background: rgba(37, 100, 207, 0.08);
  border-color: rgba(37, 100, 207, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 100, 207, 0.1);
}

.bid-item-title {
  color: #808080;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.bid-item-value {
  color: #1e1e1e;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  border: 1px solid #e8e8e8;
}

.credit-rating {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.rating-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.rating-icon img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 8px;
}

.rating-text {
  color: #808080;
  font-size: 14px;
  text-align: center;
}

/* 合同进度内容区域 */
.contract-progress-content {
  width: 100%;
  height: 100%;
  min-height: 300px;
  overflow: auto;
  box-sizing: border-box;
}

// .custom-card-title {
//   position: relative;
//   width: 100%;
//   min-width: 390px;
//   height: 100%;
//   font-size: 1.3rem;
//   color: rgba(37, 100, 207, 0.8);
//   display: flex;
//   align-items: center;
//   white-space: nowrap;
//   padding-left: 20px;
//   box-sizing: border-box;
//   overflow: hidden;
//   text-overflow: ellipsis;
  
//   // ✅ 新增：右侧按钮容器
//   .title-right-btn {
//     margin-left: auto;
//     padding-right: 20px;
//   }
// }

/* ======================
   当前项目名：超过 20 字符省略
   ====================== */
// .breadcrumb-current-text {
//   display: inline-block;
//   max-width: 30ch;          /* ✅ 20 个字符宽度 */
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   vertical-align: bottom;
// }

// .breadcrumb-fixed {
//   color: #2564CF;
//   font-weight: bold;
//   margin-right: 4px;
//   font-size: 20px;
// }

// .breadcrumb-item {
//   color: rgba(37, 100, 207, 0.8);
//   cursor: pointer;
//   transition: color 0.3s;
//   text-decoration: none;
//   font-size: 20px;
// }

// .breadcrumb-item:hover {
//   color: rgba(37, 100, 207, 1);
//   text-decoration: underline;
// }

// .breadcrumb-separator {
//   margin: 0 8px;
//   color: rgba(105, 105, 105, 0.5);
//   font-size: 20px;
// }

// .breadcrumb-item.current {
//   color: #2564CF;
//   cursor: default;
//   font-weight: normal;
//   font-size: 20px;
// }

// .breadcrumb-item.current:hover {
//   text-decoration: none;
//   color: #2564CF;
// }

.card_content {
  height: 50%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 10px;
  font-size: 14px;

  .line {
    height: 150px;
    width: 1px;
    background: rgba(128, 128, 128, 0.7);
  }

  .card_content_item {
    display: flex;
    flex-direction: column;
    height: 100px;

    .img_box {
      margin-top: -10px;
      img {
        width: 75%;
        height: 75%;
      }

      .img_info {
        color: #808080;
        font-size: 14px;
      }
    }

    .card_content_item_title {
      margin-bottom: 15px;
      color: #808080;
    }

    .card_content_item_info {
      min-height: 24px;                // ✅ 最小高度
      line-height: 24px;

    
    }
  }
}



/* ✅ 每组：两列严格对齐 */
.bid-grid-row {
  display: grid;
  grid-template-columns: 1fr 1fr;   // ✅ 左右等宽
  gap: 14px;                       // ✅ 列间距
  margin-bottom: 12px;             // ✅ 行间距
}

.bid-grid-col {
  min-width: 0;                    // ✅ 防止文本溢出
  display: flex;
  flex-direction: column;
  align-items: center;          /* 新增：水平居中 */
  text-align: center;          /* 新增：文本居中 */

    .card_content_item_title,
  .card_content_item_info {
    text-align: center;
    width: 100%;               /* 确保占满整行 */
  }
}

/* ✅ 标题统一高度 / 间距 */
.bid-grid-col .card_content_item_title {
  height: 15px;                   // ✅ 固定高度
  line-height: 22px;
  margin-bottom: 6px;              // ✅ 统一间距
  // color: #808080;
  // font-size: 14px;
}

/* ✅ 内容统一高度 / 间距 */
.bid-grid-col .card_content_item_info {

  color: #303132;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ======================
   手机端：三张卡纵向排列
   ------------------------------------------------------------
   高度链（让合同卡真正占据页面剩余高度）：
     .project-info-page → .project-info-card (height:100%)
       → .card-box (flex 列，flex:1 撑满 card-main − card-title)
         → .project-dashboard (flex:1 撑满 card-box，Grid 确定)
             ├─ row1: .basic-info-section  (min=max = $m-basic-min-h)
             ├─ row2: .bid-info-section     (min=max = $m-bid-min-h)
             └─ row3: .contract-section     minmax($m-contract-min-h, 1fr)  ← 吃剩余
   「长屏合同卡太高、表格填不满留空白」的问题由内层链解决：
     .contract-section → card-m → card-box → card-table → el-table → body-wrapper
     每一层都是 flex:1 + min-height:0 + 表格内部 overflow-y:auto，
     所以合同卡多高表格就铺多高并自己滚——**没有空白也不会顶破**。
   ------------------------------------------------------------
   想调手机端的间距 / 高度，只改下面这几个变量
   ====================== */
$m-gap: 10px;               /* 卡片之间的间距 */
$m-basic-min-h: 190px;      /* 基本信息卡最小高度 */
$m-bid-min-h: 155px;        /* 投标信息卡最小高度（手机端紧凑布局） */
$m-contract-min-h: 300px;   /* 合同信息卡最小高度 */
$m-contract-max-h: 600px;   /* 合同信息卡最大高度（超过就表格在卡片内部滚） */

@media (max-width: 768px) {
  /* ✅ 外层 card-m：撑满 .project-info-page（让合同卡有「页面剩余高度」可吃） */
  .project-info-card {
    height: 100% !important;
    min-height: 0 !important;
  }

  .project-dashboard {
    /* ✅ 保持 Grid，只换成单列三行 */
    grid-template-columns: 1fr !important;
    /* ✅ 前两张按内容高度（min=max 固定），合同卡用 minmax(min, 1fr) 吃剩余页面高度
       ⚠️ 用 1fr 而不是 auto：auto 会让合同卡只跟内容走，页面大时下方就留空白 */
    grid-template-rows: auto auto minmax($m-contract-min-h, 1fr) !important;
    grid-template-areas:
      "basic-info"
      "bid-info"
      "contract" !important;

    /* ⚠️ 不用 height:100%：父级 .card-box 的 height 是 auto，百分比解析不出来会退化成 auto，
       1fr 就拿不到确定高度，合同卡就只会撑到 min-height。
       改由 flex 撑满 card-box（card-box 是 flex 列容器），高度才是确定的。 */
    flex: 1 1 auto !important;
    min-height: 0 !important;

    width: 100% !important;
    min-width: 0 !important;
    gap: $m-gap;
    box-sizing: border-box;
  }

  /* ✅ 三个区域：撑满各自格子，左右不留多余边距 */
  .basic-info-section,
  .bid-info-section,
  .contract-section {
    width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  /* ✅ 前两张：确定一个最小高度 */
  .basic-info-section { 
    min-height: $m-basic-min-h !important; 
     max-height: $m-basic-min-h !important; 
  }
  .bid-info-section   { 
    min-height: $m-bid-min-h !important; 
  max-height: $m-bid-min-h !important; }

  /* ✅ 合同卡：撑满第三行（minmax($m-contract-min-h, 1fr)）= 真正占据页面剩余高度
     · 至少 $m-contract-min-h（页面太矮时不低于 300px，minmax 兜底）
     · 最多 $m-contract-max-h（页面太高时封顶 600px，多了不撑）
     · 中间任意高度 = 页面剩余高度 — 这就是之前想要的效果
     表格在 card-m → card-box → card-table → el-table__body-wrapper 整条链内部滚，
     不会把卡片撑高，也不会盖到外层 card-main 的 padding。 */
  .contract-section {
    height: 100% !important;
    min-height: $m-contract-min-h !important;
    max-height: $m-contract-max-h !important;
  }

  /* ✅ 内层卡片撑满各自格子（去掉 card-M 自带的右边距，左右才对称） */
  .basic-info-section > .card-main,
  .bid-info-section > .card-main {
    width: 100% !important;
    min-width: 0 !important;
    margin-right: 0 !important;
    flex: 1 !important;
    min-height: 0 !important;
  }

  /* ✅ 合同卡整条链都要能收缩（和 contractinfo 的 task-section 同一套）：
     ContractProgress 根(.contract) → card-m(.card-main) → .card-box → .card-table
     少了 min-height:0，表格一高就拒绝收缩、直接把卡片顶破，
     溢出到外层 card-main 的底部 padding 上 ——「padding 被遮到」就是这个症状 */
  .contract-section ::v-deep .contract,
  .contract-section ::v-deep .card-main,
  .contract-section ::v-deep .card-box {
    width: 100% !important;
    min-width: 0 !important;
    margin-right: 0 !important;
    flex: 1 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .contract-section ::v-deep .card-table {
    flex: 1 !important;
    min-height: 0 !important;
  }

  ::v-deep .card-main1 {
    padding: 0 !important;
    padding-bottom: 5px !important;
    box-sizing: border-box;
  }
  // .basic-info-section,
  // .bid-info-section {
  //   transform: scale(1);
  //   transform-origin: top left;

  //   /* 防止被遮挡 */
  //   z-index: 1;
  // }
  /* ======================
     基本信息 & 投标信息：整体字体变小
     ====================== */
  .basic-info-section,
  .bid-info-section {
    font-size: 12px !important;
    line-height: 1.4;
  }

  /* 字段标题 */
  .basic-info-section ::v-deep .card-info-table .label-cell,
  .bid-info-section ::v-deep .card_content_item_title {
    font-size: 11px !important;
    color: #909399;
  }

  /* 字段值 */
  .basic-info-section ::v-deep .card-info-table .value-cell,
  .bid-info-section ::v-deep .card_content_item_info {
    font-size: 12px !important;
    color: #303133;
  }

  /* 投标信息里的图标文字 */
  .bid-info-section ::v-deep .img_info {
    font-size: 11px !important;
  }

  /* 进度条百分比文字 */
  .bid-info-section ::v-deep .el-progress__text {
    font-size: 11px !important;
  }

  /* ✅ 基本信息表格：移动端 4 列平均分布 */
  .basic-info-section ::v-deep .info-row[data-cols="4"] {
    grid-template-columns: 1fr 2fr 1fr 2fr;
  }

  .bid-info-section {
    font-size: 12px !important; /* ✅ 基准字体 */
  }

  .bid-info-section .img_box img {
    width: 3em !important;   /* ✅ 跟着字体走 */
    height: 3em !important;
    object-fit: contain;
  }

  .bid-info-section .img_info {
    font-size: 11px !important;
  }

  /* ======================
     投标信息卡片：手机端紧凑布局（只命中 .bid-info-section，不动其他卡片）
     —— 把桌面端写死的 180px 行高 / 150px 分隔线 / 15px 标题间距全部压下来
     ====================== */
  .bid-info-section ::v-deep .card_content_item {
    height: 100px !important;            /* 原 180px：上排 3 块的行高 */
  }

  .bid-info-section ::v-deep .card_content_item_title {
    margin-bottom: 10px !important;       /* 原 15px：标题与内容的距离 */
  }

  .bid-info-section ::v-deep .card_content_item_info {
    min-height: 0 !important;            /* 原 24px：让字段值跟着内容走 */
    line-height: 1.4 !important;         /* 原 24px：行高别写死 */
  }

  .bid-info-section ::v-deep .line {
    height: 95px !important;             /* 原 150px：上排 3 块之间的竖向分隔线 */
  }

  .bid-info-section ::v-deep .bid-grid-row {
    margin-bottom: 4px !important;       /* 原 12px：下面 2 行之间的间距 */
    gap: 10px !important;                /* 原 16px：列间距 */
  }

  .bid-info-section ::v-deep .bid-grid-col .card_content_item_title {
    height: auto !important;             /* 原 15px：标题别写死高度 */
    line-height: 1.3 !important;         /* 原 22px */
    margin-bottom: 2px !important;       /* 原 6px */
  }

  .bid-info-section ::v-deep .bid-grid-col .card_content_item_info {
    min-height: 0 !important;            /* 原 24px */
    line-height: 1.4 !important;         /* 原 24px */
  }

  /* 进度环从 80px 缩到 56px */
  .bid-info-section ::v-deep .el-progress--circle,
  .bid-info-section ::v-deep .el-progress--circle .el-progress-circle {
    width: 56px !important;
    height: 56px !important;
  }




}
// @media (max-height: 700px) {
//   .project-dashboard {
//     grid-auto-rows: minmax(180px, auto);
//   }
  
//   .bid-item {
//     min-height: 80px;
//     padding: 8px;
//   }
  
//   .rating-icon img {
//     width: 60px;
//     height: 60px;
//   }
// }




</style>